"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.duplicateOperations = exports.pathShape = exports.operations = exports.operationIdOf = exports.endpoints = exports.documents = exports.documentTitle = exports.filterByAudience = exports.makeRoot = exports.addGroups = exports.makeApi = exports.normalizeGroups = exports.versionPrefix = exports.Version = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const ProtocolError = __importStar(require("../v2/spec/error"));
const Audience = __importStar(require("./audience"));
const Order = __importStar(require("./order"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Compose';
/** The two Unified API versions and the path segment each is rooted at. */
exports.Version = { V1: 'v1', V2: 'v2' };
const versionPrefix = (version) => `/${version}`;
exports.versionPrefix = versionPrefix;
/**
 * Orders groups deterministically and drops repeated registrations.
 *
 * Groups arrive from independently delivered modules, so the same group may
 * be registered twice (e.g. once by a version registry and once by a document
 * filter). Two *different* groups sharing an identifier is a mistake, because
 * `HttpApi.add` would silently replace the first with the second.
 */
const normalizeGroups = (groups) => {
    const byIdentifier = new Map();
    for (const group of groups) {
        const existing = byIdentifier.get(group.identifier);
        if (existing !== undefined && existing !== group) {
            throw new Error(`${exports.NAMESPACE}: two different groups share the identifier "${group.identifier}"`);
        }
        byIdentifier.set(group.identifier, group);
    }
    return Array.from(byIdentifier.values()).sort((a, b) => Order.compare(a.identifier, b.identifier));
};
exports.normalizeGroups = normalizeGroups;
/**
 * An empty API speaking the Unified API wire protocol.
 *
 * Both a failed request decode (400) and an unknown route (404) are answered
 * in the `{ success: false, error: { type, ... } }` envelope, like every
 * legacy route does through `RestApiEndpoint`.
 */
const makeApi = (id) => {
    const proto = platform_1.HttpApi.make(id);
    // @ts-expect-error: hacking the object until https://github.com/Effect-TS/effect/pull/5654 lands
    proto.errorSchema = ProtocolError.HttpApiDecodeErrorFromValidationErrorFromProtocol;
    return proto.addError(ProtocolError.RouteNotFoundFromNotFoundErrorFromProtocol);
};
exports.makeApi = makeApi;
/** Adds groups to an API in deterministic order. */
const addGroups = (api, groups) => (0, exports.normalizeGroups)(groups).reduce((acc, group) => acc.add(group), api);
exports.addGroups = addGroups;
/**
 * Builds a plain API root: groups, `/v1` or `/v2` prefix and document title.
 *
 * The `/api` prefix and the application version are *not* applied here; see
 * `Generate.toOpenApi`, which applies both exactly once.
 */
const makeRoot = (options, groups) => {
    const api = (0, exports.addGroups)((0, exports.makeApi)(options.id), groups)
        .prefix((0, exports.versionPrefix)(options.version))
        .annotate(platform_1.OpenApi.Title, options.title);
    return options.description === undefined
        ? api
        : api.annotate(platform_1.OpenApi.Description, options.description);
};
exports.makeRoot = makeRoot;
/** Groups documented for the given audience, deterministically ordered. */
const filterByAudience = (groups, audience) => (0, exports.normalizeGroups)(groups).filter(Audience.isFor(audience));
exports.filterByAudience = filterByAudience;
/** Human readable name of a document, e.g. `Admin API`. */
const documentTitle = (audience) => `${audience.charAt(0).toUpperCase()}${audience.slice(1)} API`;
exports.documentTitle = documentTitle;
/**
 * Builds one document per audience from a shared pool of groups.
 *
 * `build` receives the filtered groups and is expected to apply the version
 * specific base (middleware, global errors, prefix, ...). The result is keyed
 * by audience and always contains every audience, possibly with no groups.
 */
const documents = (groups, build) => {
    // Normalized once; filtering preserves the order, so each audience gets a
    // deterministic slice without repeating the sort and dedup pass.
    const pool = (0, exports.normalizeGroups)(groups);
    const entries = Audience.ALL.map(audience => [audience, build(audience, pool.filter(Audience.isFor(audience)))]);
    return Object.fromEntries(entries);
};
exports.documents = documents;
/** Every endpoint with the group that declares it, in group/endpoint order. */
const endpoints = (api) => Object.values(api.groups).flatMap(group => Object.values(group.endpoints).map(endpoint => [group, endpoint]));
exports.endpoints = endpoints;
/**
 * The `operationId` `OpenApi.fromApi` generates for an endpoint.
 *
 * Mirrors Effect, which qualifies the endpoint name with the group identifier
 * unless the group is top level, and lets `OpenApi.Identifier` override both.
 */
const operationIdOf = (group, endpoint) => effect_1.Context.getOrElse(endpoint.annotations, platform_1.OpenApi.Identifier, () => group.topLevel ? endpoint.name : `${group.identifier}.${endpoint.name}`);
exports.operationIdOf = operationIdOf;
/** `METHOD /path` for every endpoint in the API, in group/endpoint order. */
const operations = (api) => (0, exports.endpoints)(api).map(([, endpoint]) => `${endpoint.method} ${endpoint.path}`);
exports.operations = operations;
/**
 * A path with its parameter names erased.
 *
 * `/rules/:ruleId` (endpoint form) and `/rules/{id}` (generated form) both
 * become `/rules/{}`. OpenAPI treats templates that differ only in parameter
 * names as the same path, and parameter names are invisible on the wire, so
 * this is the identity paths must be unique by.
 */
const pathShape = (path) => path.replace(/:\w+|\{\w+\}/g, '{}');
exports.pathShape = pathShape;
/**
 * Operations that resolve to the same `METHOD` and {@link pathShape}.
 *
 * Reports the operations as declared, so `GET /x/rules/:id` and
 * `GET /x/rules/:ruleId` are both listed when two groups disagree on a
 * parameter name. An operation declared twice verbatim is listed once.
 */
const duplicateOperations = (api) => {
    const byShape = new Map();
    for (const operation of (0, exports.operations)(api)) {
        const shape = (0, exports.pathShape)(operation);
        byShape.set(shape, [...(byShape.get(shape) ?? []), operation]);
    }
    const duplicates = new Set();
    for (const declared of byShape.values()) {
        if (declared.length > 1)
            for (const operation of declared)
                duplicates.add(operation);
    }
    return Order.sorted(duplicates);
};
exports.duplicateOperations = duplicateOperations;
//# sourceMappingURL=compose.js.map